<template src="./html/Export.html"></template>

<script>
	import Ladda from 'ladda'
	import FileSaver from 'file-saver'
	import swal from 'sweetalert2'

	export default {
		props: ['user', 'isAuth', 'dataExport', 'dataFilter'],
		components: {

		},
		data () {
			return {
				filter: {},

				buttons: {
					pdf: {
						loading: false,
					},
					xls: {
						loading: false,
					},
					csv: {
						loading: false,
					}
				},
			}
		},
		created () {
		},
		methods: {
			exportData(type, button) {
				this.dataExport.type = type
				button.loading = true
				var data = {
					filter: this.dataFilter,
					export: this.dataExport,
				}
				this.$http.post(this.dataExport.url, data, {responseType: 'blob'})
					.then(response => {
						if(this.dataFilter.report_type) {
							var report_type = this.dataFilter.report_type
						} else {
							var report_type = ''
						}
						var date = moment().format('D-M-Y')
						button.loading = false
						var file = response.body
						var blob = new Blob([file], {type: type})
						var file_name = report_type + date + '.'+type
						FileSaver.saveAs(blob, file_name)
					}).catch(function(response) {
						button.loading = false
						swal({
							title: response.statusText,
							text: response.body,
							type: "warning"
						});
					})
			},
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/projects/export/Export.vue